import { IconWrapper } from '../runtime';
export default IconWrapper('offline', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("circle", {
    "attrs": {
      "cx": "1",
      "cy": "1",
      "r": "1",
      "transform": "matrix(1 0 0 -1 7 13.9919)",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M1 5.57187C1.28321 5.30017 1.58219 5.04479 1.89545 4.80725C2.37292 4.44518 2.88355 4.12455 3.42197 3.85072L3.64175 3.74888M10.205 10.3175C9.61267 9.79476 8.83463 9.47755 7.98249 9.47755C7.13036 9.47755 6.35231 9.79476 5.76 10.3175M3.42197 7.91815C4.12944 7.25948 4.97917 6.75159 5.92 6.44564L6.22768 6.33482M2.19259 2.29973L3.64175 3.74888M12.0921 12.1992L6.22768 6.33482M3.64175 3.74888L6.22768 6.33482",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M10.205 6.48765C11.0961 6.79706 11.902 7.28876 12.578 7.91813M15 5.56622C13.1831 3.82312 10.7167 2.75189 8 2.75189C7.78002 2.75189 7.56169 2.75892 7.3452 2.77275C7.1144 2.7875 6.8857 2.81 6.65936 2.83997",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});